import {
  differenceInMinutes,
  differenceInMonths,
  endOfMonth,
  getDay,
  setDate,
  setHours,
  setMinutes,
  setMonth
} from 'date-fns';
import { NUMBER_OF_DAYS_IN_WEEK } from '../../constants';
import type { ScheduleSolversDisplayConfigType } from '../../types';
import { getDateFromControlValue } from '../../utils/get-date-obj';

export const lastDayInMonth = ({
  freq = 1,
  endDate,
  startDate,
  userDate,
  scheduleRepeatEnds,
  scheduleRepeatEndsDate,
  scheduleRepeatEndsOccurrences
}: ScheduleSolversDisplayConfigType) => {
  const viewDurationInMonths = differenceInMonths(endDate, startDate);
  const monthPassedFromStart = differenceInMonths(userDate, startDate);

  const viewDurationInMinutes = differenceInMinutes(endDate, startDate);

  const startHour = startDate.getHours();
  const startMinutes = startDate.getMinutes();

  const endOfMonthDate = endOfMonth(userDate);
  const endOfMonthDateDay = endOfMonthDate.getDate();

  const lastWeekDates = [];
  for (
    let i = endOfMonthDateDay;
    i > endOfMonthDateDay - NUMBER_OF_DAYS_IN_WEEK;
    i--
  ) {
    const date = setDate(endOfMonthDate, i);
    const weekDay = getDay(date);
    lastWeekDates[weekDay] = i;
  }

  const startDateDay = getDay(startDate);

  const dayInThisMonth = lastWeekDates[startDateDay];

  const startDateInThisMonth = setMinutes(
    setHours(setDate(userDate, dayInThisMonth), startHour),
    startMinutes
  );

  const endDateInThisMonth = new Date(
    startDateInThisMonth.getTime() + viewDurationInMinutes * 60 * 1000
  );

  if (
    scheduleRepeatEnds === 'onDate' &&
    userDate.getTime() >=
      getDateFromControlValue(scheduleRepeatEndsDate).getTime()
  ) {
    return false;
  }

  if (scheduleRepeatEnds === 'afterOccurrences') {
    const endRepeatMonth = setMonth(
      startDate,
      startDate.getMonth() + freq * Number(scheduleRepeatEndsOccurrences)
    );
    const endOfMonthDate = endOfMonth(endRepeatMonth);
    const endOfMonthDateDay = endOfMonthDate.getDate();

    const lastWeekDates = [];
    for (let i = endOfMonthDateDay; i >= endOfMonthDateDay - 6; i--) {
      const date = new Date(endOfMonthDate.setDate(i));
      const weekDay = getDay(date);
      lastWeekDates[weekDay] = i;
    }

    const startDateDay = getDay(startDate);

    const dayInThisMonth = lastWeekDates[startDateDay];

    const startDateInThisMonth = setMinutes(
      setHours(setDate(endRepeatMonth, dayInThisMonth), startHour),
      startMinutes
    );

    if (userDate.getTime() > startDateInThisMonth.getTime()) {
      return false;
    }
  }

  return (
    userDate.getTime() >= startDate.getTime() &&
    userDate.getTime() >= startDateInThisMonth.getTime() &&
    userDate.getTime() <= endDateInThisMonth.getTime() &&
    monthPassedFromStart % freq <= viewDurationInMonths
  );
};
